/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef } from "react";
import { useSelector } from "react-redux";
import { withTranslation } from "react-i18next";

import { Label, UncontrolledTooltip } from "reactstrap";

import Select from "react-select";

import {
  isFunction,
  isNumber,
} from "../../../Libs/CustomMethods/customMethods";

import "./lightTheme.scss";

const importDarkMode = (mainTheme) => {
  if (mainTheme === "dark") {
    require("./darkTheme.scss");
  }
};

const InputTime = ({ t, ...props }) => {
  const { mainTheme } = useSelector((state) => state.Layout);
  const [newValue, setNewValue] = useState({});
  const [value, setValue] = useState({ value: "" });

  const selectRef = useRef(null);

  importDarkMode(mainTheme);

  const style = {
    width: props?.width ?? "auto",
    ...props?.style,
  };

  const periodOptions = [
    {
      unity: "Seconds",
      label: t("Seconds"),
    },
    {
      unity: "minutes",
      label: t("Minutes"),
    },
    {
      unity: "hours",
      label: t("Hours"),
    },
    {
      unity: "days",
      label: t("Days"),
    },
  ];

  if (props.notDays) {
    periodOptions.pop();
  }
  const timeToObj = (minutes) => {
    if (props.isSeconds) {
      if (minutes / 60 < 1 || minutes % 60 !== 0) {
        return { value: minutes, unity: "seconds" };
      }
      minutes = minutes / 60;
    }

    if (minutes >= 0) {
      if (minutes % 24 === 0 && (minutes / 24) % 60 === 0) {
        return { value: minutes / 24 / 60, unity: "days" };
      } else {
        if (minutes % 60 === 0) {
          return { value: minutes / 60, unity: "hours" };
        } else {
          return { value: minutes, unity: "minutes" };
        }
      }
    } else {
      return null;
    }
  };

  const objToMinutes = (obj) => {
    if (obj?.unity) {
      let minutes = 0;
      switch (obj?.unity) {
        case "days":
          minutes = minutes * 24 * 60;
          break;
        case "hours":
          minutes = minutes * 60;
          break;
        default:
          break;
      }

      return parseInt(minutes);
    }
  };

  const objToSeconds = (obj) => {
    if (obj?.unity) {
      let seconds = obj.value || 0;

      switch (obj?.unity) {
        case "days":
          seconds = seconds * 24 * 60 * 60;
          break;
        case "hours":
          seconds = seconds * 60 * 60;
          break;
        case "minutes":
          seconds = seconds * 60;
          break;
        default:
          break;
      }
      return parseInt(seconds);
    }
  };

  const handleInput = (e) => {
    let select = selectRef?.current;
    let val = e?.target?.value;
    let regex = new RegExp(/[^0-9]/g);

    if (val === "") {
      setNewValue((prev) => ({ ...prev, value: "" }));
    }
    if (val && regex.test(val)) {
      setValue(val.replace(regex, ""));
    } else {
      if (select) {
        let obj = {
          value: val,
          unity: select?.state?.value?.unity,
        };
        let time = props.isSeconds
          ? objToSeconds(obj) || -1
          : objToMinutes(obj) || 0;

        if (props.isSeconds) {
          setNewValue((prev) => ({ ...prev, value: time }));
          setValue((prev) => ({ ...prev, value: val }));
        } else {
          isNumber(time) && setNewValue((prev) => ({ ...prev, value: time }));
          setValue((prev) => ({ ...prev, value: val }));
        }
      }
    }
  };

  const handleSelect = (e) => {
    let unity = e?.unity;
    let val = value?.value;

    if (unity) {
      let obj = {
        value: val,
        unity,
      };

      let time = props.isSeconds
        ? objToSeconds(obj) || -1
        : objToMinutes(obj) || 0;

      if (props.isSeconds) {
        setNewValue((prev) => ({ ...prev, value: time }));
      } else {
        isNumber(time) && setNewValue((prev) => ({ ...prev, value: time }));
      }
    }
  };

  const handleSubmit = () => {
    isFunction(props?.onChange) && props?.onChange(newValue);
  };

  const tooltips = useCallback(() => {
    return (
      <UncontrolledTooltip placement="bottom" target={`eventInfo-${props?.id}`}>
        {t(props?.tooltip)}
      </UncontrolledTooltip>
    );
  }, [props?.id, props?.tooltip, t]);

  const title = useCallback(() => {
    return (
      <div className="d-flex justify-content-between w-100">
        <Label className="d-flex control-label align-items-center pr-2">
          {t(props?.title ?? "")}
          <i
            className="fas fa-info-circle px-2 pointer"
            id={`eventInfo-${props?.id}`}
          ></i>
        </Label>
        {tooltips()}
      </div>
    );
  }, [props?.disabled, props?.id, props?.title, t, tooltips]);

  const description = (isSkill) => {
    return (
      <div className="descriptionContainer flex-grow-1">
        <span>
          {isSkill
            ? t(props?.descriptionSkill ?? "")
            : t(props?.description ?? "")}
          :
        </span>
      </div>
    );
  };
  const input = useCallback(() => {
    return (
      <div
        className={`select2-container mx-3 inputContainer ${
          !props.description && "inputContainer-long"
        }`}
      >
        <input
          size={2}
          placeholder="Ex: 5"
          onChange={handleInput}
          disabled={props?.disabled ?? false}
          defaultValue={value.value}
          {...props?.inputProps}
        />
      </div>
    );
  }, [props?.disabled, value?.value, props?.inputProps]);

  const getItem = (el) => {
    return el !== undefined
      ? periodOptions?.find((e) => e?.unity === el?.unity) ?? null
      : periodOptions[0];
  };

  const weekDays = useCallback(() => {
    return (
      <div className="select2-container selectContainer">
        <Select
          ref={selectRef}
          classNamePrefix="select2-selection"
          className={`${props?.disabled ? "isDisabled" : ""}`}
          options={periodOptions}
          placeholder={t("Choose") + "..."}
          onChange={handleSelect}
          isDisabled={props?.disabled ?? false}
        />
      </div>
    );
  }, [props?.disabled, t, value]);

  const updateFields = () => {
    let select = selectRef?.current?.state;
    let obj = props?.defaultValue && timeToObj(props?.defaultValue);
    if (select) {
      if (obj) {
        select.value = getItem(obj) ?? getItem();
      } else {
        select.value = getItem("5") ?? getItem();
      }
    }
  };

  useEffect(() => {
    updateFields();
    isNumber(props?.defaultValue) && setValue(timeToObj(props?.defaultValue));
  }, [props?.defaultValue]);

  useEffect(() => {
    if (props?.options) {
      isNumber(newValue?.value) && newValue?.skill && handleSubmit();
    } else {
      isNumber(newValue?.value) && handleSubmit();
    }
  }, [newValue]);

  return (
    <>
      <div
        className={`chatEvent ${props.mb ? props.mb : "mb-3"} ${
          !props.notHasBox && " chatEvent-box d-flex flex-column rounded p-3"
        } `}
        style={style}
      >
        {!props.notHasTitle && (
          <>
            <div
              className={`d-flex align-items-center ${
                !props.notHasBox && "mb-2"
              }`}
            >
              {title()}
            </div>
          </>
        )}
        <div className="d-flex align-items-center mt-2">
          {props.description && <>{description(false)}</>}
          {input()}
          {weekDays()}
        </div>
      </div>
    </>
  );
};

export default withTranslation()(React.memo(InputTime));
